export default function getResource(label, vars = []) {
    const resources = {
        brandLink: 'Shop this brand'
    };
    return resources[label];
}
